export const ENDPOINT_APPROVAL_SETTINGS = '/approval-settings';
export const ENDPOINT_GET_BANK_HOLIDAYS = '/staticData/GetCurrentDepartmentBankHolidays';

export default function TripApprovalService(
    $http
) {
    'ngInject';

    Object.assign(this, {
        isApprovalProcess,
        retrieveApprovalSettings,
        fetchBankHolidays,
    });

    function isApprovalProcess(tripData, isBook) {
        return (isBook && !tripData.IsApproved && tripData.ApprovalSettings && tripData.ApprovalSettings.IsApprovalRequired)
            || !!tripData.OutOfPolicyReasons
            || !!tripData.LowestFareReasons;
    }

    function retrieveApprovalSettings() {
        return $http.apiGET(ENDPOINT_APPROVAL_SETTINGS)
            .then(({data}) => data);
    }


    function fetchBankHolidays() {
        return $http.apiGET(ENDPOINT_GET_BANK_HOLIDAYS, {cache: true})
            .then(({data}) => data);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-approval/trip-approval-service.js